import { render, staticRenderFns } from "./PiprTrack.vue?vue&type=template&id=58572642&lang=pug"
import script from "./PiprTrack.vue?vue&type=script&lang=js"
export * from "./PiprTrack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports